import React, { useState } from 'react';

export default function IndexSectionFaqs6() {
    const [openFaq, setOpenFaq] = useState(null);

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    const faqs = [
        {
            question: "How does Ordio protect my data and uploads?",
            answer: "We ensure your data stays protected by encrypting your data at rest and in-transit to ensure data integrity."
        },
        {
            question: "Is there a limit to what I can upload?",
            answer: "Currently, Ordio is not enforcing any storage limits for its users"
        },
        {
            question: "What can I upload?",
            answer: "You can upload documents, photos, videos and audio recordings. Ordio will help you sort and AI will help you tag and fetch your items!"
        }
    ];

    return (
        <React.Fragment>
            <>
                <section id="faq" className="relative py-20">
                    <img className="hidden lg:block absolute top-0 left-0 mt-16" src="zeus-assets/icons/dots/blue-dot-left-bars.svg" alt="" />
                    <img className="hidden lg:block absolute bottom-0 right-0 mb-20" src="zeus-assets/icons/dots/yellow-dot-right-shield.svg" alt="" />
                    <div className="container px-4 mx-auto">
                        <div className="max-w-2xl mx-auto text-center mb-12">
                            <h2 className="mt-8 mb-10 text-4xl font-semibold font-heading">Frequently Asked Questions</h2>
                            <p className="text-xl text-gray-500">Here are some common answers to frequent questions that we receive from our users</p>
                        </div>
                        <div className="max-w-3xl mx-auto">
                            <ul>
                                {faqs.map((faq, index) => (
                                    <li key={index} className="px-6 py-8 border-b">
                                        <button 
                                            onClick={() => toggleFaq(index)}
                                            className="w-full flex justify-between items-center text-left font-semibold font-heading"
                                        >
                                            <span className="text-2xl font-semibold font-heading">{faq.question}</span>
                                            <span className={`inline-block text-gray-500 transform transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}>
                                                <svg className="flex-shrink-0" width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.75 10C0.75 15.108 4.891 19.25 10 19.25C15.108 19.25 19.25 15.108 19.25 10C19.25 4.892 15.108 0.75 10 0.75C4.891 0.75 0.75 4.892 0.75 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6.52881 8.55774L9.99981 12.0437L13.4708 8.55774" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                        </button>
                                        <div className={`overflow-hidden transition-all duration-500 ${openFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                                            <p className="mt-4 text-lg text-gray-500 leading-loose">{faq.answer}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </section>
            </>
        </React.Fragment>
    );
}